import { SequenceMenuItemType } from '@sequencehq/core-components'
import { ContractReferenceType } from 'Cube/domain/cube.domain.types'
import { CONTRACT_REFERENCE_TYPE_CONFIG } from './contractReferences.constants'
import { usePhaseContractReferences } from './usePhaseContractReferences'

type MenuItem = Extract<SequenceMenuItemType, { label: string }>

/**
 * "Add reference" in the phase menu, with a choice of type underneath. A type
 * the phase already has is left out (other references excepted), and is
 * changed from its badge instead.
 */
export const useContractReferenceMenuItems = (props: {
  phaseId: string
  onAdd: (type: ContractReferenceType) => void
}): Array<MenuItem> => {
  const contractReferences = usePhaseContractReferences({
    phaseId: props.phaseId
  })

  if (!contractReferences.isVisible) {
    return []
  }

  const subItems = contractReferences.addableTypes.map(type => {
    const { label, Icon } = CONTRACT_REFERENCE_TYPE_CONFIG[type]

    return {
      label,
      iconLeft: <Icon />,
      onClick: () => props.onAdd(type),
      'data-testid': `phase.contractReferences.add.${type}`
    }
  })

  return [
    {
      label: 'Add reference',
      subItems,
      isDisabled: !contractReferences.canEdit || !subItems.length,
      divider: true,
      'data-testid': 'phase.contractReferences.add'
    }
  ]
}
